import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'equine-ui-nx-onboard-successful',
  standalone: true,
  imports: [
    CommonModule,
    MatIcon
  ],
  templateUrl: './onboard-successful.component.html',
  styleUrl: './onboard-successful.component.scss',
})
export class OnboardSuccessfulComponent {}
